import sourceRedactions from './source-redactions.generated.json';

/**
 * Owner decision 2026-10-07 (lean/redact_disclaimers.py source-map): component source texts (pt-BR originals) with the
 * disclaimer sentences/tags deleted; '' = the whole text was a disclaimer (the caller hides the element).
 */
const SOURCE_REDACTIONS = sourceRedactions as Readonly<Record<string, string>>;

export const redactSourceText = (text: string): string => (Object.prototype.hasOwnProperty.call(SOURCE_REDACTIONS, text) ? (SOURCE_REDACTIONS[text] as string) : text);
